import React from "react"
import * as d3 from 'd3';
import PropTypes from "prop-types";
import Marker from "./Marker";

const Markers = ({ data, xAccessor, yAccessor, type, size, selectedPoint, clickState, onClick, mapType}) => {

  return (
    <React.Fragment>
      <g className="Markers">
          {data.map((d, i) => (
              <Marker
                d={d}
                x={xAccessor(d, i)}
                y={yAccessor(d, i)}
                type={type}
                size={size}
                selectedName={selectedPoint}
                clickedName={clickState}
                onClick={onClick}
                mapType={mapType}
              />
          ))}
      </g>
    </React.Fragment>
  )
}

Markers.propTypes = {
    type: PropTypes.object,
    size: PropTypes.number,
    color: PropTypes.string,
}

Markers.defaultProps = {
    type: d3.symbolCircle,
    size: 100,
    color: "#9980FA"
}

export default Markers
